// extracted by mini-css-extract-plugin
export default {"motto":"Motto_motto__498qO","mottoWrapper":"Motto_mottoWrapper__tSjRS"};